/** How much a new user used during their Clinician trial, against a Clinician Standard seat. */
export enum ClinicianTrialEndedUsageClass {
  /** Used the full Standard allowance or more, so the trial modal recommends Max. */
  MoreThanStandard = 'more_than_standard',
  WithinStandard = 'within_standard',
}

export type ClinicianTrialEndedUsage = {
  usageClass: ClinicianTrialEndedUsageClass;
  /** Share of the Standard limit used, capped at 100; `null` when either side is unknown. */
  usagePercent: number | null;
};

const toCredits = (value: string | null | undefined): number | null => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Compares trial usage with the full monthly Clinician Standard limit, which a
 * trialing Standard cycle carries unprorated. Missing usage or limit reads as
 * within Standard, so every ended trial still gets the modal.
 */
export function classifyClinicianTrialUsage({
  consumed,
  standardLimit,
}: {
  consumed: string | null | undefined;
  standardLimit: string | null | undefined;
}): ClinicianTrialEndedUsage {
  const used = toCredits(consumed);
  const limit = toCredits(standardLimit);
  if (used == null || limit == null || limit <= 0) {
    return {
      usageClass: ClinicianTrialEndedUsageClass.WithinStandard,
      usagePercent: null,
    };
  }
  return {
    usageClass:
      used >= limit
        ? ClinicianTrialEndedUsageClass.MoreThanStandard
        : ClinicianTrialEndedUsageClass.WithinStandard,
    usagePercent: Math.min(100, Math.round((used / limit) * 100)),
  };
}
